import SalesPeriodicity from './SalesPeriodicity';

export default SalesPeriodicity;
